import { h, Component, Host, Element, Prop } from '@stencil/core';

import { getCSSVariable } from '../../../services/utils';

@Component({
  tag: 'pk-list-item',
  styleUrl: './scss/pk-list-item.scss',
  shadow: true,
})
export class PkListItem {
  // Own Properties
  // ====================

  // Reference to host HTML element
  // ===================================

  @Element() el!: HTMLPkListItemElement;

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  /** Specify a valid background color token */
  @Prop() bgColor: string;

  /** Specify if the item has divider */
  @Prop() hasDivider: boolean = true;

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // These methods cannot be called from the host element.
  // =======================================================

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    const style = {
      ...(this.bgColor && {
        '--list-item--background-color': getCSSVariable(this.bgColor),
      }),
    };

    return (
      <Host style={{ ...style }}>
        <div class="flex items-center bg-[color:--list-item--background-color] font-semibold" part="base">
          <div class="text-s text-text-03" part="prefix">
            <slot name="prefix-card" />
          </div>
          <div class="mx-s" part="body">
            <slot />
          </div>
          <div class="flex-1 text-right text-text-01" part="suffix">
            <slot name="suffix-card" />
          </div>
        </div>
        {this.hasDivider && (
          <pk-divider class="divider--horizontal block" direction="horizontal" part="divider"></pk-divider>
        )}
      </Host>
    );
  }
}
